
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 34 34","height":"32","width":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('g',{attrs:{"fill-rule":"nonzero","fill":"#000"}},[_c('g',{attrs:{"transform":"translate(6.625 2.1)"}},[_c('circle',{attrs:{"r":"1.879","cy":"2.781","cx":"4.229","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"10.463","cx":"7.365","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"5.508","cx":"8.757","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"7.387","cx":"14.504","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"8.584","cx":"2.35","vector-effect":"non-scaling-stroke"}})]),_c('path',{attrs:{"d":"M20.682 22.772l1.204 3.85L15.893 30l-5.78-3.377 1.205-3.85h9.364zm-1.103 1.5H12.42l-.519 1.658 4.005 2.34 4.186-2.359-.513-1.639z","vector-effect":"non-scaling-stroke"}})])])])
          )
        }
      }
    